/**
 * Admin Dashboard Charts
 * Renders Chart.js visualizations for subscription trends
 */

export function initAdminCharts() {
  const canvas = document.getElementById('subscriptionChart');
  if (!canvas) return;

  // Chart may have been initialized inline in the view to avoid a timing flash;
  // skip if a Chart.js instance is already attached to this canvas.
  if (typeof Chart !== 'undefined' && Chart.getChart(canvas)) return;

  if (typeof Chart === 'undefined') {
    console.error('Chart.js failed to load.');
    return;
  }

  const chartData = window.subscriptionChartData;
  if (!chartData) {
    console.warn('No chart data available.');
    return;
  }

  // Muted, harmonious color palette
  const styles = [
    { border: '#2e8540', bg: 'rgba(46, 133, 64, 0.08)' },   // Green  - New Users
    { border: '#1779ba', bg: 'rgba(23, 121, 186, 0.08)' },   // Blue   - Active Subs
    { border: '#cc4b37', bg: 'rgba(204, 75, 55, 0.08)' },    // Red    - Cancelled Subs
    { border: '#8e6bb0', bg: 'rgba(142, 107, 176, 0.08)' },  // Purple - Gift Subs
    { border: '#e6a817', bg: 'rgba(230, 168, 23, 0.08)' },   // Amber  - Complimentary
    { border: '#6c757d', bg: 'rgba(108, 117, 125, 0.08)' },  // Grey   - Imported (hidden by default)
  ];

  chartData.datasets.forEach(function(ds, i) {
    var s = styles[i] || styles[0];
    ds.borderColor = s.border;
    ds.backgroundColor = s.bg;
    ds.tension = 0.4;
    ds.pointRadius = 4;
    ds.pointHoverRadius = 6;
    ds.pointBackgroundColor = '#fff';
    ds.pointBorderWidth = 2;
    ds.borderWidth = 2;
    ds.fill = true;
  });

  new Chart(canvas.getContext('2d'), {
    type: 'line',
    data: chartData,
    options: {
      responsive: true,
      maintainAspectRatio: true,
      interaction: {
        mode: 'index',
        intersect: false
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            stepSize: 1
          },
          grid: {
            color: 'rgba(0, 0, 0, 0.06)'
          }
        },
        x: {
          grid: {
            display: false
          }
        }
      },
      plugins: {
        legend: {
          display: true,
          position: 'top',
          labels: {
            usePointStyle: true,
            padding: 20
          }
        },
        tooltip: {
          mode: 'index',
          intersect: false
        }
      }
    }
  });
}
